window.contactValidationTwMessage = {
    ask_the_topic: {
        required: "請正確填寫此欄位",
    },
    content: {
        required: "請正確填寫此欄位",
        maxlength: "已超過字數上限",
    },
    name: {
        required: "請正確填寫此欄位",
        maxlength: "已超過字數上限",
    },
    company_name: {
        maxlength: "已超過字數上限",
    },
    address: {
        maxlength: "已超過字數上限",
    },
    email: {
        required: "請正確填寫此欄位",
        email: "請正確填寫此欄位",
        maxlength: "已超過字數上限",
    },
    tel: {
        maxlength: "已超過字數上限",
        tel: "請正確填寫此欄位",
    },
    privacy: {
        required: "請勾選此欄位",
    },
};
